import { UPGRADE_FLOW_SOURCES } from "@circle-react-shared/UpgradePlan/constants";
import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { PlusCustomOfferSummary } from "@/react/components/SettingsApp/Plan/PlanSettings/experiment/PlusCustomOfferSummary";
import { PlusPlanSummary } from "@/react/components/SettingsApp/Plan/PlanSettings/experiment/PlusPlanSummary";
import { usePlans } from "@/react/components/SettingsApp/Plan/RegularPlan/PlansContext";

const I18N_ROOT = "pricing_plans.upgrade_modal.enterprise_plus.right_pane";
const PLUS_PAGE_URL = "https://circle.so/plus";

const SOURCE_TO_CTA_HREF: Partial<Record<string, string>> = {
  [UPGRADE_FLOW_SOURCES.ACTIVITY_LOGS_SPLASH_SCREEN]: PLUS_PAGE_URL,
};

interface RightPaneProps {
  source?: string;
}

export const RightPane = ({ source }: RightPaneProps) => {
  const { customPlanOffer } = usePlans();

  return (
    <div className="bg-secondary p-6 rounded-xl flex justify-center">
      {customPlanOffer ? (
        <PlusCustomOfferSummary />
      ) : (
        <PlusPlanSummary
          title={
            <Typography.LabelLg weight="bold" color="text-dark">
              {t(`${I18N_ROOT}.title`)}
            </Typography.LabelLg>
          }
          description={t(`${I18N_ROOT}.description`)}
          source="upgrade_modal"
          ctaHref={source ? SOURCE_TO_CTA_HREF[source] : undefined}
        />
      )}
    </div>
  );
};
